import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from '@design-system/box';
import { Dotdotdot } from '@design-system/dotdotdot';
import { CATEGORIES, FontAwesomeIcon } from '@design-system/font-awesome-icon';
import { useI18n } from '@design-system/i18n';
import { Cover } from './Cover';
import { GroupAndContentType } from './GroupAndContentType';
import { LinkWrapper } from './LinkWrapper';
const DEFAULT_DISPLAY_FIELDS = {
    contentType: false,
    company: false,
    group: false,
    location: false,
};
export const OpportunityPresentation = ({ contentTypeName, data: { companyName, group, image, location, name }, displayFields = DEFAULT_DISPLAY_FIELDS, onClick, path, withLink, }) => {
    const { __ } = useI18n();
    return (_jsxs(Box, { flexDirection: { _: 'column', m: 'row' }, width: "100%", children: [_jsx(Box, { mb: { _: 4, m: 0 }, mr: { _: 0, m: 5 }, children: _jsx(ImageWrapper, { children: _jsx(Cover, { fallbackIconName: "briefcase", imageSrc: image, onClick: onClick, path: path, withLink: withLink }) }) }), _jsxs(Box, { flexDirection: "column", justifyContent: "center", width: "100%", children: [((displayFields.group && group) || displayFields.contentType) && (_jsx(GroupAndContentType, { group: displayFields.group ? group : undefined, type: displayFields.contentType
                            ? contentTypeName !== null && contentTypeName !== void 0 ? contentTypeName : __('Opportunity')
                            : undefined })), _jsx(Box, { children: _jsx(LinkWrapper, { font: "h4-semibold", onClick: onClick, path: path, withLink: withLink, children: _jsx(Dotdotdot, { clamp: 2, children: name }) }) }), displayFields.company && companyName && (_jsx(Box, { font: "body-semibold-asphalt", mt: 1, children: _jsx(Dotdotdot, { clamp: 1, children: companyName }) })), displayFields.location && location && (_jsxs(Box, { alignItems: "center", mt: 1, children: [_jsx(Box, { justifyContent: "center", mr: 1, width: "12px", children: _jsx(FontAwesomeIcon, { height: "12px", iconName: "location-dot", iconType: CATEGORIES.SOLID }) }), _jsx(Dotdotdot, { clamp: 1, children: location })] }))] })] }));
};
const ImageWrapper = styled(Box).attrs(() => ({
    width: '72px',
    height: '72px',
    flexShrink: 0,
})) `
  border-radius: ${({ theme }) => `${theme.themeVariables.globalBorderRadius}px`};
  overflow: hidden;
`;
//# sourceMappingURL=OpportunityPresentation.js.map